import { Bounce, gsap, Power2, Power0 } from 'gsap';
import { CustomEase } from "gsap/dist/CustomEase";
import { SanSymbolData } from "../../engine/Symbol/SanSymbolData";
import { Sequence } from "../../../core/displayobject/Sequence";
import { SanQuentin2 } from "../../SanQuentin2";
import { Helper } from "../../../core/utils/Helper";
import { MathHelper } from '../../../core/utils/MathHelper';
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';

class Dude extends Sequence {

    private dudeTypes:string[] = ["walkingDude","benchDude"]
    private mode:number = 0;

    private moveTl:gsap.core.Timeline | undefined;

    private moveDurr:number = 4;
    private turnDurr:number = 0.2;
    private get createDude():PIXI.Texture[]{
        this.mode = MathHelper.randomIntInRange(0,this.dudeTypes.length-1);// Math.floor(Math.random()*this.dudeTypes.length)%this.dudeTypes.length;
        return SanQuentin2.assetLoader.getTextures(this.dudeTypes[this.mode]);
    }

    public playDude(value:boolean):void{
        if(!this.visible) return;
        this.moveTl = Helper.setTimeline(this.moveTl,{repeat:-1});
        if(value){
            if(this.mode == 0) {
                this.position.x = -50;
                this.moveTl.to(this.scale,{x:1,ease:"Power0.easeIn",duration:this.turnDurr},0);
                this.moveTl.to(this.position,{x:50,ease:"Power0.easeIn",duration:this.moveDurr},0);

                this.moveTl.to(this.scale,{x:-1,ease:"Power0.easeIn",duration:this.turnDurr},this.moveDurr);
                this.moveTl.to(this.position,{x:-50,ease:"Power0.easeIn", duration:this.moveDurr},this.moveDurr);
                this.moveTl.play(Math.random()*3)
            }else
                this.position.set(0,-10);
            this.play({repeat:-1, speedFactor: 2 }).play(Math.random());
        } else{
            this.stop();
            this.moveTl.kill();
            this.visible = false;
        }
    }

    public changeDude():void{
        this.visible = Math.random() > 0.63;
        this.setTexture(this.createDude);
        this.playDude(true);
    }
}

export class RevealerBar extends PIXI.Container {

    protected source_core_path: string = "Blocks/";

    protected openEase: any = CustomEase.create("barOpen", "M0,0 C0,0 0.017,0.05923 0.03452,0.0674 0.05798,0.07834 0.09868,0.06172 0.13589,0.06337 0.15398,0.06417 0.17636,0.0618 0.18403,0.07404 0.29662,0.25364 0.3972,0.46468 0.53823,0.7052 0.56583,0.75227 0.5866,0.77732 0.62137,0.81986 0.67628,0.88704 0.71309,0.93149 0.76917,0.98772 0.78129,0.99988 0.79643,1.01014 0.8117,1.01073 0.845,1.01202 0.87691,0.99561 0.91578,0.9934 0.9469,0.99162 1,1 1,1 ");

    protected seq_bar: Sequence;
    protected seq_bar_overlay: Sequence;

    protected text: PIXI.Text;
    private dude:Dude;

    protected barPath: string = "";

    private maskElement: PIXI.Graphics;

    protected _timeLine: gsap.core.Timeline;
    protected _rezTimeline: gsap.core.Timeline;

    private isTop: boolean = false;

    constructor(path: string) {
        super();
        this.barPath = path;
        this.isTop = path === "Block_Top_Bars";
        this.init();
    }

    protected init(): void {

        this.dude = this.addChild(new Dude(SanQuentin2.assetLoader.getTextures("walkingDude")));
        this.dude.anchor.set(0.5);
        this.dude.position.y = -10;

        this.dude.changeDude();

        this.seq_bar = this.createSeq(SanQuentin2.assetLoader.getTextures(this.source_core_path + this.barPath));
        this.seq_bar.height = SanSymbolData.fetchSymHeightSize(2);

        this.seq_bar_overlay = this.createSeq(SanQuentin2.assetLoader.getTextures(this.source_core_path + this.barPath));
        this.seq_bar_overlay.blendMode = PIXI.BLEND_MODES.ADD;
        this.seq_bar_overlay.alpha = 0;

        this.maskElement = this.createGraphic();
        this.maskElement.alpha = 0.00000001;

    }

    private createGraphic(grow: boolean = false): PIXI.Graphics {
        const graphicBg: PIXI.Graphics = new PIXI.Graphics();

        const c: number = 0x000000;
        graphicBg.beginFill(c, 1);

        const recTop: number = this.isTop ? 0 : -this.seq_bar.height;
        const recHeight: number = this.seq_bar.height;

        graphicBg.drawRect(-SanSymbolData.DEFAULT_DIM.WIDTH * 0.5, -recHeight / 2,
            SanSymbolData.DEFAULT_DIM.WIDTH, recHeight);

        graphicBg.endFill();

        this.addChild(graphicBg);
        return graphicBg;
    }

    private createSeq(texture: PIXI.Texture[]): Sequence {
        const seq: Sequence = new Sequence(texture);
        seq.alpha = 1;
        seq.anchor.set(0.5, 0.5);
        this.addChild(seq);
        return seq;
    }

    public open(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, {
            onStart: () => {
                this.mask = this.maskElement;
                SoundManager.playSoundEffect(SoundConfig.CELL_TOPBOT_OPEN,undefined,true);
            },
            onComplete: () => {
                this.mask = null!;
                this.seq_bar.visible = false;
            }
        });

        const dirr: number = this.isTop ? -SanSymbolData.DEFAULT_DIM.HEIGHT / 2 : SanSymbolData.DEFAULT_DIM.HEIGHT / 2;
        this._timeLine.to(this.seq_bar.position,
            {
                y: dirr,
                ease: this.openEase,
                duration: 0.30
            },0);

        this._timeLine.to(this.dude,{alpha:0, ease:this.openEase,duration: 0.3},0)

        this._timeLine.add(() => this.dude.playDude(false));

        return this._timeLine;
    }

    public close(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, {
            onStart: () => {
                this.mask = this.maskElement;
                this.seq_bar.visible = true;
                SoundManager.playSoundEffect(SoundConfig.CELL_TOPBOT_CLOSE,undefined,true);
            },
            onComplete: () => {
                this.mask = null!;
            }
        });

        this.dude.changeDude();
        this._timeLine.add([
            gsap.to(this.dude,{duration:0.25, alpha:1}),
            gsap.to(this.seq_bar.position, { y: 0, duration: 0.25 })
        ],0);

        return this._timeLine;
    }
}